export default class APICertification {
  constructor(API) {
    this.api = API;
  }
  //Certs
  async getByUserIDAndCertID(userID, certID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/certification/${certID}`;
    return await req.exec();
  }
  async getByUserID(userID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/certifications`;
    return await req.exec();
  }
  async getExpandedByUserID(userID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/certifications/expanded`;
    return await req.exec();
  }
  async getUpcomingCoursesByUserID(userID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/certifications/upcomingCourses`;
    return await req.exec();
  }
  async createByUserIDAndCertSpecsID(userID, certSpecsID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certSpecsID}`;
    return await req.exec();
  }
  async renewCertificationByUserIDAndCertID(userID, certID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/renew`;
    return await req.exec();
  }
  async restartCertificationByUserIDAndCertID(userID, certID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/restart`;
    return await req.exec();
  }

  async moveCertificationToUser(userID, certID, targetUserID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/move/${targetUserID}`;
    return await req.exec();
  }

  async validateMoveCertificationToUser(userID, certID, targetUserID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/move/${targetUserID}/validate`;
    return await req.exec();
  }

  //Redeem
  async redeemLicense({ userID, certID, ...body }) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/redeem`;
    req.body = { ...body };
    return await req.exec();
  }
  async batchRedeem(certID, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/certification/${certID}/course/batchRedeem`;
    req.body = { ...body };
    return await req.exec();
  }

  //Invite
  async batchInvite(certID, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/certification/${certID}/course/batchInvite`;
    req.body = { ...body };
    return await req.exec();
  }

  //Certification card
  //TO BE IMPLEMENTED
  // async getPrintingCard(userID) {
  //   const request = await this.api.newBaseRequest('GET');
  //   request.path = Globals.APIPath_User + userID + Globals.APIPath_Certification + Globals.APIPath_CertificationPrint;
  //   request.bodyType = 'BINARY';
  //   return await request.exec();
  // }
  async getPrintingCertificate(userID, certID) {
    const request = await this.api.newBaseRequest("GET");
    request.bodyType = "BLOB";
    request.path = `/user/${userID}/certification/${certID}/print`;
    return await request.exec();
  }

  /* waive */
  async toogleWaiveStatus(userID, certID, comments, waive) {
    const request = await this.api.newBaseRequest("POST");
    request.path = `/user/${userID}/certification/${certID}/waive`;
    request.body = { waive: !!waive, comments: comments || "" };
    return await request.exec();
  }

  async courseCertificatePrint(userID, certID, courseID) {
    const request = await this.api.newBaseRequest("GET");
    request.bodyType = "BLOB";
    request.path = `/user/${userID}/certification/${certID}/course/${courseID}/print`;
    return await request.exec();
  }

  async setCertificationDates(userID, certID, expiryDate, completionDate) {
    const request = await this.api.newBaseRequest("PUT");
    request.path = `/user/${userID}/certification/${certID}/setDates`;
    request.body = { expiryDate, completionDate };
    return await request.exec();
  }
}
